import React, { Component } from 'react'

import { connect, batch } from 'react-redux';
import { styles } from '../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, Typography, Divider } from '@material-ui/core';


import { withRouter } from 'react-router';
import { getLocationPathName } from '../selectors/util.selector';
import { DatePicker } from "material-ui-pickers";
import moment, { Moment } from 'moment'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import { isCommitDialogOpen } from '../selectors/phaseplan.selector';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { dialogActions } from '../actions/dialog.actions';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { lookaheadActions } from '../actions/lookahead.actions';
import { getCommitmentDay, getMinCommitmentDate } from '../selectors/lookahead.selector';
import DayPicker from './DayPicker';

interface Props {
    isCommitDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    savePromiseTagsByDates: (starteDate:number, endDate:number) => void,
    saveCommitmentDay: (day: number) => void,
    minDate: string,
    initCommitmentDay?: number,
    removeCommitmentDay: () => void
}

type State = {
    startDate: number,
    endDate: number,
    day?: number
}


class CommitChooserComponent extends Component<Props, State> {
    constructor(props:Props) {
        super(props)

        this.state = {
            startDate: moment().valueOf(),
            endDate: moment().valueOf(),
            day: props.initCommitmentDay
        }
    }


    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    handleStartDateChange = (value: Moment) => {
        const date = value.valueOf()
        this.setState({
            startDate: date
        })
    }

    handleEndDateChange = (value: Moment) => {
        const date = value.valueOf()
        this.setState({
            endDate: date
        })
    }

    handleDateClicked = (newDay: number) => {
        const { day } = this.state
        if(day === newDay) {
            this.setState({
                day: null
            })
        } else {
            this.setState({
                day: newDay
            })
        }
    }

    onConfirm = () => {
        const { startDate, endDate, day } = this.state
        const { savePromiseTagsByDates, closeDialogValue, minDate, saveCommitmentDay, removeCommitmentDay } = this.props
        if(day === undefined || day === null) {
            
            batch(() => {
                
                savePromiseTagsByDates(startDate, endDate)
                removeCommitmentDay()
                closeDialogValue()
            })
        } else {
            saveCommitmentDay(day)
            closeDialogValue()
        }
    }

    onRemove = () => {
        const { startDate, endDate, day } = this.state

        const { removeCommitmentDay, closeDialogValue } = this.props
            batch(() => {

                removeCommitmentDay()
                closeDialogValue()
            })
        
    }

    onEnter = () => {
        this.setState({
            startDate: moment().valueOf(),
            endDate: moment().valueOf(),
            day: this.props.initCommitmentDay
        })
    }

    render() {
        const { classes, minDate } = this.props;
        const { startDate, endDate, day } = this.state

        const invisibleTop = !!day ? classes.GONE : ''
        return (
            <Dialog
                maxWidth='sm'
                fullWidth={true}
                open={!!this.props.isCommitDialogOpen}
                onEnter={this.onEnter}
                onBackdropClick={this.closeDialog.bind(this)}
            >
                <DialogContent>
                    <div style={{backgroundColor: ''}} className={classes.DialogFormTitle}>
                        <p className={classes.DialogFormTitleText}>
                            Commit Work
                        </p>
                    </div>
                    <div>
                        <div className={classes.DialogFormContent} >
                            <div className={invisibleTop}>
                                <Typography variant="subtitle1">
                                    Choose A Date Range
                                </Typography>
                                <div style={{display: 'flex', justifyContent: 'space-around'}}>
                                    <DatePicker minDate={moment(minDate,'l')} maxDate={moment(endDate)} value={moment(startDate)} onChange={this.handleStartDateChange} label="Start Date" />
                                    <DatePicker minDate={moment(startDate)} value={moment(endDate)} onChange={this.handleEndDateChange} label="End Date" />
                                </div>
                            </div>
                            <div  style={{display: 'flex', flexDirection: 'row', width:'100%'}} className={invisibleTop}>
                                <Divider /> Or <Divider />
                            </div>
                            
                            <div>
                                <Typography variant="subtitle1">
                                    Choose A Weekly Commitment Day
                                </Typography>

                                <DayPicker value={day} onDayClicked={this.handleDateClicked} />
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                    <Button onClick={this.onRemove}  color="primary"> Remove </Button>

                    <Button onClick={this.onConfirm}  color="primary"> Confirm </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state:any) => ({
    isCommitDialogOpen: isCommitDialogOpen(state),
    minDate: getMinCommitmentDate(state),
    initCommitmentDay: getCommitmentDay(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(dialogActions.closeCommitDialog()),
        savePromiseTagsByDates: (startDate:number, endDate:number) => dispatch(lookaheadActions.savePromiseTagsByDates(startDate, endDate)),
        saveCommitmentDay: (day:number) => dispatch(lookaheadActions.saveCommitmentDay(day)),
        removeCommitmentDay: () => dispatch(lookaheadActions.removeCommitmentDay())
    }
};


export default compose<React.ComponentClass>(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true }),
)(CommitChooserComponent)


// WEBPACK FOOTER //
// ./src/components/CommitChooser.tsx